// BUILD-046 correction cycle 1bb88b3e (stage B2b, items N2 and N3): the rule of the dialog focus trap, kept apart from the DOM so it is tested.
//
// While a modal dialog is open, Tab and Shift+Tab stay inside it: Tab on the last focusable control goes to the first, Shift+Tab on the first goes to the
// last, and focus that somehow sits outside the dialog is brought back in. Anywhere else the browser moves focus as usual. When the dialog closes, focus
// returns to the control that opened it (the hook does that; this module only decides where Tab goes).
//
// Pure module. Erasable TypeScript only.

export interface TrapDecision {
  /** True when the caller must stop the browser's own Tab and focus `index` itself. */
  prevent: boolean;
  /** The focusable control to focus when `prevent` is true. */
  index: number;
}

/**
 * `count` focusable controls in the dialog; `activeIndex` is the index of the focused one, or -1 when focus is not on any of them (it is on the dialog
 * itself or outside it). With nothing focusable, Tab is held in place (index -1: the caller keeps focus on the dialog).
 */
export function trapTab(count: number, activeIndex: number, shiftKey: boolean): TrapDecision {
  if (count <= 0) return { prevent: true, index: -1 };
  if (activeIndex < 0 || activeIndex >= count) return { prevent: true, index: shiftKey ? count - 1 : 0 };
  if (!shiftKey && activeIndex === count - 1) return { prevent: true, index: 0 };
  if (shiftKey && activeIndex === 0) return { prevent: true, index: count - 1 };
  return { prevent: false, index: activeIndex + (shiftKey ? -1 : 1) };
}
